import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  Grid,
  CircularProgress,
  Backdrop,
  Typography,
  useTheme,
  Tabs,
  Tab,
  styled,
  Fab,
  Stack,
  Icon,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { RemMensaje } from "../../redux/actions/mensajes";
import { getCargando, getMensaje, getDias } from "../../redux/selectors";
import { GetDias, Solicitar } from "../../redux/actions/dias";
import SolicitarDias from "./solicitarDias";
import Feriados from "./feriados";
import Guardados from "./guardados";
import Solicitudes from "./solicitudes";

const Dias = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const paramIng = useParams();

  const [color, setColor] = React.useState({
    main: theme.palette.background.default,
    selected: "lightgray",
    pText: theme.palette.text.primary,
    sText: theme.palette.text.secondary,
    pText2: theme.palette.text.primary,
    sText2: theme.palette.text.secondary,
  });
  const { enqueueSnackbar /*, closeSnackbar*/ } = useSnackbar();
  const backdrop = useSelector((state) => getCargando(state));
  const mensaje = useSelector((state) => getMensaje(state));
  const listado = useSelector((state) => getDias(state));
  const [opcion, setOpcion] = React.useState(0);

  const [params, setParams] = React.useState(null);
  const [seleccionados, setSeleccionados] = React.useState([]);
  const [openSol, setOpenSol] = React.useState(false);

  const CustomTabs = styled(Tabs)({
    "& .MuiTabs-indicator": {
      backgroundColor: color.pText,
    },
  });

  const CustomTab = styled((props) => <Tab disableRipple {...props} />)(
    ({ theme }) => ({
      whiteSpace: "nowrap",
      color: color.sText,
      "&.Mui-selected": {
        color: color.pText,
      },
    }),
  );

  React.useEffect(() => {
    if (mensaje.mensaje !== "") {
      enqueueSnackbar(mensaje.mensaje, {
        preventDuplicate: true,
        anchorOrigin: { vertical: "bottom", horizontal: "center" },
        variant: mensaje.variant,
        autoHideDuration: 3000,
      });
      dispatch(RemMensaje());
    }
  }, [mensaje]);

  React.useEffect(() => {
    if (paramIng.modo && paramIng.modo === "1") {
      document.body.style.backgroundColor = "#2f3035";
      setColor({
        main: "#2f3035",
        pText: "white",
        sText: "#ACACAC",
        selected: "black",
        pText2: color.pText,
        sText2: color.sText,
      });
    }
    const p = {
      conductor: paramIng.conductor,
      token: paramIng.token,
    };
    setParams(p);
    dispatch(GetDias({ Conductor: p.conductor, Token: p.token }));
  }, []);

  return (
    <React.Fragment>
      <Stack
        sx={{
          p: 0,
          overflowY: "hidden",
          height: "100vh",
          maxHeight: "100vh",
        }}
      >
        <Backdrop
          sx={{
            zIndex: theme.zIndex.drawer + 1,
          }}
          open={backdrop}
        >
          <CircularProgress />
        </Backdrop>

        <CustomTabs
          variant="fullWidth"
          value={opcion}
          onChange={(e, nv) => setOpcion(nv)}
        >
          <CustomTab value={0} label="Feriados" />
          <CustomTab value={1} label="Reservados" />
          <CustomTab value={2} label="Solicitudes" />
        </CustomTabs>

        {!backdrop &&
          listado &&
          ((opcion === 0 &&
            listado.feriados &&
            listado.feriados.length === 0) ||
            (opcion === 1 &&
              listado.guardados &&
              listado.guardados.length === 0) ||
            (opcion === 2 &&
              listado.solicitudes &&
              listado.solicitudes.length === 0)) && (
            <Typography
              sx={{
                mt: 4,
                flexGrow: 1,
                display: "flex",
                justifyContent: "center",
              }}
              color="error"
            >
              No hay datos a mostrar.
            </Typography>
          )}
        {!backdrop &&
          listado &&
          ((opcion === 0 && listado.feriados && listado.feriados.length > 0) ||
            (opcion === 1 &&
              listado.guardados &&
              listado.guardados.length > 0) ||
            (opcion === 2 &&
              listado.solicitudes &&
              listado.solicitudes.length > 0)) && (
            <Stack
              sx={{
                overflow: "auto",
                height: "calc(100vh - 80px)",
                mt: 2,
              }}
            >
              <Stack spacing={2}>
                {opcion === 0 && ( // listado de feriados
                  <Feriados
                    listado={listado.feriados}
                    params={params}
                    color={color}
                  />
                )}
                {opcion === 1 && ( // listado de guardados
                  <Guardados
                    listado={listado.guardados}
                    params={params}
                    color={color}
                    seleccionados={seleccionados}
                    setSeleccionados={setSeleccionados}
                  />
                )}
                {opcion === 2 && ( // listado de solicitudes
                  <Solicitudes
                    listado={listado.solicitudes}
                    params={params}
                    color={color}
                  />
                )}
              </Stack>
            </Stack>
          )}
      </Stack>
      {opcion === 1 &&
        !backdrop &&
        listado.guardados &&
        listado.guardados.length > 0 &&
        seleccionados.length > 0 && (
          <Grid
            container
            sx={{
              position: "absolute",
              bottom: 0,
              right: 0,
              zIndex: 1002,
              margin: "5px",
            }}
            spacing={1}
          >
            <Grid size={12} sx={{ justifyContent: "end", display: "flex" }}>
              <Fab
                size="small"
                color="primary"
                sx={{ borderRadius: "15px" }}
                onClick={() => setOpenSol(true)}
              >
                <Icon>playlist_add_check</Icon>
              </Fab>
            </Grid>
            <Grid size={12} sx={{ height: "40px" }} />
          </Grid>
        )}

      <SolicitarDias
        open={openSol || false}
        onClose={() => setOpenSol(false)}
        cantidad={(seleccionados && seleccionados.length) || 0}
        onSave={(v) => {
          dispatch(
            Solicitar({
              Conductor: params.conductor,
              Fecha: v.fecha,
              Dias: seleccionados.join(", "),
              Motivo: v.motivo,
              Token: params.token,
            }),
          );

          setSeleccionados([]);
          setOpenSol(false);
        }}
      />
    </React.Fragment>
  );
};

export default Dias;
